<app-auth-layout>
  <h2>Verifica tu correo</h2>
  <h6>para continuar con Dicea</h6>
  <br>
  <ngx-spinner bdColor="rgba(255,255,255,0.8)" name="spVerifyCodeCorreo" size="default" color=" var(--primary-color)"
    type="ball-atom" [fullScreen]="false">
  </ngx-spinner>

  <div class="row">
    <form [formGroup]="form">

      <div class="col">
        <div class="email-input">
          <input matInput type="text" formControlName="Correo" class="w-100" disabled>
        </div>
        <div class="verification-label">Codigo de verificación</div>
        <p>Introduzca el código de verificación enviado a su dirección de correo electrónico</p>
        <app-input-otp #otpInput [idUsuario]="idUsuario" [length]="6"
          (otpComplete)="onOtpComplete($event)"></app-input-otp>
      </div>
    </form>
  </div>
</app-auth-layout>
